"use strict";
/* Generated from:
 * ap-northeast-1 (https://d33vqc0rt9ld30.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-2 (https://d1ane3fvebulky.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-south-1 (https://d2senuesg1djtx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-1 (https://doigdx0kgq9el.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-2 (https://d2stg8d246z9di.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ca-central-1 (https://d2s8ygphhesbe7.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-central-1 (https://d1mta8qj7i28i2.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-1 (https://d3teyb21fexa9r.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-2 (https://d1742qcu2c1ncx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-3 (https://d2d0mfegowb3wk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * sa-east-1 (https://d3c9jyj3w509b0.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-1 (https://d1uauaxba7bl26.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-2 (https://dnwj8swjjbsbt.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-1 (https://d68hl49wbnanq.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-2 (https://d201a2mn26r7lk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = require("../resource");
class IncrementalPullConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.IncrementalPullConfig = IncrementalPullConfig;
class PrefixConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.PrefixConfig = PrefixConfig;
class S3OutputFormatConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.S3OutputFormatConfig = S3OutputFormatConfig;
class DestinationFlowConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DestinationFlowConfig = DestinationFlowConfig;
class DatadogSourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DatadogSourceProperties = DatadogSourceProperties;
class AggregationConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AggregationConfig = AggregationConfig;
class ScheduledTriggerProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ScheduledTriggerProperties = ScheduledTriggerProperties;
class DestinationConnectorProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DestinationConnectorProperties = DestinationConnectorProperties;
class ConnectorOperator {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConnectorOperator = ConnectorOperator;
class ZendeskSourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ZendeskSourceProperties = ZendeskSourceProperties;
class SalesforceDestinationProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SalesforceDestinationProperties = SalesforceDestinationProperties;
class ErrorHandlingConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ErrorHandlingConfig = ErrorHandlingConfig;
class S3SourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.S3SourceProperties = S3SourceProperties;
class SalesforceSourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SalesforceSourceProperties = SalesforceSourceProperties;
class SingularSourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SingularSourceProperties = SingularSourceProperties;
class EventBridgeDestinationProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.EventBridgeDestinationProperties = EventBridgeDestinationProperties;
class MarketoSourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MarketoSourceProperties = MarketoSourceProperties;
class SlackSourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SlackSourceProperties = SlackSourceProperties;
class RedshiftDestinationProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RedshiftDestinationProperties = RedshiftDestinationProperties;
class LookoutMetricsDestinationProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.LookoutMetricsDestinationProperties = LookoutMetricsDestinationProperties;
class SourceFlowConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SourceFlowConfig = SourceFlowConfig;
class UpsolverS3OutputFormatConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.UpsolverS3OutputFormatConfig = UpsolverS3OutputFormatConfig;
class UpsolverDestinationProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.UpsolverDestinationProperties = UpsolverDestinationProperties;
class ServiceNowSourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ServiceNowSourceProperties = ServiceNowSourceProperties;
class ZendeskDestinationProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ZendeskDestinationProperties = ZendeskDestinationProperties;
class InforNexusSourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InforNexusSourceProperties = InforNexusSourceProperties;
class S3DestinationProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.S3DestinationProperties = S3DestinationProperties;
class SourceConnectorProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SourceConnectorProperties = SourceConnectorProperties;
class TrendmicroSourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TrendmicroSourceProperties = TrendmicroSourceProperties;
class SnowflakeDestinationProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SnowflakeDestinationProperties = SnowflakeDestinationProperties;
class GoogleAnalyticsSourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.GoogleAnalyticsSourceProperties = GoogleAnalyticsSourceProperties;
class VeevaSourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VeevaSourceProperties = VeevaSourceProperties;
class DynatraceSourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DynatraceSourceProperties = DynatraceSourceProperties;
class Task {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.Task = Task;
class TaskPropertiesObject {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TaskPropertiesObject = TaskPropertiesObject;
class TriggerConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TriggerConfig = TriggerConfig;
class AmplitudeSourceProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AmplitudeSourceProperties = AmplitudeSourceProperties;
class Flow extends resource_1.ResourceBase {
    constructor(properties) {
        super('AWS::AppFlow::Flow', properties);
    }
}
exports.default = Flow;
Flow.IncrementalPullConfig = IncrementalPullConfig;
Flow.PrefixConfig = PrefixConfig;
Flow.S3OutputFormatConfig = S3OutputFormatConfig;
Flow.DestinationFlowConfig = DestinationFlowConfig;
Flow.DatadogSourceProperties = DatadogSourceProperties;
Flow.AggregationConfig = AggregationConfig;
Flow.ScheduledTriggerProperties = ScheduledTriggerProperties;
Flow.DestinationConnectorProperties = DestinationConnectorProperties;
Flow.ConnectorOperator = ConnectorOperator;
Flow.ZendeskSourceProperties = ZendeskSourceProperties;
Flow.SalesforceDestinationProperties = SalesforceDestinationProperties;
Flow.ErrorHandlingConfig = ErrorHandlingConfig;
Flow.S3SourceProperties = S3SourceProperties;
Flow.SalesforceSourceProperties = SalesforceSourceProperties;
Flow.SingularSourceProperties = SingularSourceProperties;
Flow.EventBridgeDestinationProperties = EventBridgeDestinationProperties;
Flow.MarketoSourceProperties = MarketoSourceProperties;
Flow.SlackSourceProperties = SlackSourceProperties;
Flow.RedshiftDestinationProperties = RedshiftDestinationProperties;
Flow.LookoutMetricsDestinationProperties = LookoutMetricsDestinationProperties;
Flow.SourceFlowConfig = SourceFlowConfig;
Flow.UpsolverS3OutputFormatConfig = UpsolverS3OutputFormatConfig;
Flow.UpsolverDestinationProperties = UpsolverDestinationProperties;
Flow.ServiceNowSourceProperties = ServiceNowSourceProperties;
Flow.ZendeskDestinationProperties = ZendeskDestinationProperties;
Flow.InforNexusSourceProperties = InforNexusSourceProperties;
Flow.S3DestinationProperties = S3DestinationProperties;
Flow.SourceConnectorProperties = SourceConnectorProperties;
Flow.TrendmicroSourceProperties = TrendmicroSourceProperties;
Flow.SnowflakeDestinationProperties = SnowflakeDestinationProperties;
Flow.GoogleAnalyticsSourceProperties = GoogleAnalyticsSourceProperties;
Flow.VeevaSourceProperties = VeevaSourceProperties;
Flow.DynatraceSourceProperties = DynatraceSourceProperties;
Flow.Task = Task;
Flow.TaskPropertiesObject = TaskPropertiesObject;
Flow.TriggerConfig = TriggerConfig;
Flow.AmplitudeSourceProperties = AmplitudeSourceProperties;
